import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonCol, IonContent, IonGrid, IonRow, IonSpinner } from '@ionic/angular/standalone';
import { SafariAnimateDirective } from '../../components/safari-animate.directive';

@Component({
  selector: 'app-initial-loading',
  templateUrl: './initial-loading.page.html',
  styleUrls: ['./initial-loading.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SafariAnimateDirective, IonContent, IonGrid, IonCol, IonRow, IonSpinner]
})
export class InitialLoadingPage {}
